import { create } from "zustand";

const useAdminProfile = create((set) => ({
  profileData: null,
  isProfileClicked: false,

  clearProfileData: () => set({ profileData: null }),

  setProfileData: (data) => set({ profileData: data }),

  setIsProfileClicked: (value) =>
    set((state) => ({
      isProfileClicked:
        typeof value === "boolean" ? value : !state.isProfileClicked,
    })),
}));

export default useAdminProfile;
